module.exports = __webpack_public_path__ + "assets/img/_flamengo1.6c4eecff.png";